<template>
  <section>
    <ux-folder-header
      class="folder__heading"
      :name="folder.name"
      :total-files="folder.content.totalFiles"
      :total-folders="folder.content.totalFolders"
      :last-updated="folder.lastUpdated.date"
      :is-open="isOpen"
      :files-type="folder.content.filesType"
      v-on:open-container="openContainer"></ux-folder-header>
    <transition
      name="fade">
      <section
        class="folder__content"
        v-show="isOpen">
        <div
          class="text-center"
          v-if="hasNetworkError">
          <p>An error has occurred.</p>
          <p>
            <button
              class="folder__load-more"
              @click="openContainer">Reload</button>
          </p>
        </div>
        <transition name="fade">
          <section>
            <section
              class="folder__content folder__content__folders"
              v-show="folder.folders">
              <ux-folder-content-container
                class="folder"
                v-for="subfolder in folder.folders"
                v-bind:key="subfolder.id"
                v-bind:folder="subfolder"
                v-bind:size="size"></ux-folder-content-container>
            </section>
            <section
              class="folder__content folder__content__files"
              v-if="folder.files && folder.content.filesType === 'document'">
              <ux-folder-file-document
                v-bind:file="file"
                v-for="file in folder.files"
                v-bind:key="file.id"></ux-folder-file-document>
            </section>
            <section
              class="folder__content folder__content__files folder__content__files--images"
              v-if="folder.files && folder.files.length && folder.content.filesType === 'image'">
              <ux-folder-file-image
                v-bind:file="file"
                v-for="(file, index) in folder.files"
                v-bind:index="index"
                v-bind:key="file.id"
                v-on:open-gallery="onOpenGallery(index, folder.files)"></ux-folder-file-image>
            </section>
          </section>
        </transition>
        <div class="loader" v-if="isLoading">
          <img src="../../assets/images/loading-spinner.svg" alt="Loading...">
        </div>
        <p class="text-center" v-if="total > page * pageSize">
          <button class="folder__load-more"
                  v-on:click="loadMore(folder)">Load more</button>
        </p>
      </section>
    </transition>
  </section>
</template>

<script>
  import config from '../../config'
  const imagePageSize = 12;
  const pageSize = 10;

  export default {
    name: 'UXFolderContentContainer',
    data() {
      return {
        isOpen: false,
        isLoaded: false,
        isLoading: false,
        pageSize: pageSize,
        page: 1,
        total: 0,
        hasNetworkError: false
      }
    },
    props: {
      folder: Object,
      size: {
        type: String,
        validator(value) {
          return ['md', 'lg'].includes(value);
        }
      }
    },
    methods: {
      openContainer() {
        if (!this.isLoaded || this.hasNetworkError) {
          this.isLoading = true;
          this.isOpen = true;
          if (this.folder && this.folder.content && this.folder.content.filesType === 'image') {
            this.pageSize = imagePageSize;
          } else {
            this.pageSize = pageSize;
          }
          this.load(() => {
            this.isLoaded = true;
            this.isLoading = false;
            this.hasNetworkError = false;
            if (this.folder && this.folder.pagination) {
              this.total = this.folder.pagination.total;
              this.page = this.folder.pagination.page;
            }
          }, () => {
            this.isLoading = false;
            this.hasNetworkError = true;
          });
        } else {
          this.isOpen = !this.isOpen;
        }
      },
      resetPagination() {
        this.page = 1;
        this.total = 0;
      },
      loadMore() {
        this.isLoading = true;
        ++this.page;
        this.load(() => {
          this.isLoading = false;
        });
      },
      onOpenGallery(index, images) {
        this.images = images.map(image => Object.assign(image, { href: config.baseUrl + image.previewUrl }));
        this.$root.$emit('pass-images-and-index', images, index);
      },
      load(cb, err) {
        //use $root.$emit as $emit only works with child - parent and we can have folder inside a folder
        this.$root.$emit('load-data', this.folder.id, this.folder.groupId, this.pageSize, this.page, this.folder, cb, err);
      }
    }
  }
</script>
